import { Collection } from 'modules/core/lib/mobx-rest'

import Bookkeeper from 'modules/bookkeepers/store/models/Bookkeeper'

class Bookkeepers extends Collection<Bookkeeper> {
  get cacheKey(): string {
    return 'bookkeepers'
  }

  model() {
    return Bookkeeper
  }
}

const singleton: Bookkeepers = new Bookkeepers()

export default singleton
